<div class="orbits-canvas-preview" id="orbits-canvas-preview">
  <div class="orbits-canvas-preview_orbits">
    <canvas #orbitCanvas></canvas>
  </div>
</div>
